
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DateTime } from 'luxon';

import { sharedState } from '../../../../framework/state';

import { VehicleCostMonthlyRow } from '../../../../../common/application/model/VehicleCostMonthlyRow';
import { formatCurrency } from '../../../service/helper_service';
import { formatMonthStrings, monthDiff } from '../../../../../common/framework/util/time';
import { getBudgetSpentReport } from '../../../../application/client/report_client';

@Component
export default class BudgetSpent extends Vue {
    @Prop(Array) readonly customers!: string[];
    @Prop(Boolean) readonly showWithVat!: boolean;
    @Prop(String) readonly month!: string;
    @Prop(Boolean) readonly showTitle!: boolean;

    shared = sharedState;

    local = {
        rows: [] as VehicleCostMonthlyRow[],
        totalBalance: 0,
        totalBudgeted: 0,
        totalBudgetSpent: 0,
    };

    async mounted() {
        await this.loadAsyncData();
    }

    @Watch('customers')
    rowsChanged() {
        this.loadAsyncData();
    }

    @Watch('showWithVat')
    showWithVatChange() {
        this.loadAsyncData();
    }

    @Watch('month')
    monthChange() {
        this.loadAsyncData();
    }

    formatCurrencyValue(value: number | null | undefined) {
        return formatCurrency(value);
    }

    private async loadAsyncData() {
        this.local.rows = [];
        this.local.totalBalance = 0;
        this.local.totalBudgetSpent = 0;
        this.local.totalBudgeted = 0;

        if (!this.customers || this.customers.length === 0) {
            return;
        }

        const budgetSpentResult = await getBudgetSpentReport(
            this.customers,
            this.getMonthIn(this.month),
            this.showWithVat,
        );

        this.local.totalBalance = budgetSpentResult.balance;
        this.local.totalBudgetSpent = budgetSpentResult.paid;
        this.local.totalBudgeted = budgetSpentResult.invoiced;
    }

    private getMonthIn(endMonth: string): string[] {
        const beginDate = DateTime.now().startOf('year').toJSDate();
        const endDate = DateTime.fromFormat(endMonth, 'yyyy-MM').toJSDate();
        const monthCount = monthDiff(beginDate, endDate);

        return formatMonthStrings(beginDate.getFullYear(), beginDate.getMonth(), monthCount);
    }
}
